import type { ReactNode } from 'react';

import type { OrderSummaryData, OrderSummaryHandlers } from '@ctct/application-layer';
import { OrderSummary } from '@ctct/presentation-layer';
import type { OrderSummaryHooks } from '@ctct/state-client-layer';

interface Props {
  data: OrderSummaryData;
  handlers: OrderSummaryHandlers;
  hooks: OrderSummaryHooks;
  injectedMiddleComponent?: ReactNode;
  hideHeading?: boolean;
}

export const OrderSummaryWidgetContent = ({ data, handlers, injectedMiddleComponent, hooks, hideHeading }: Props) => {
  // connect this component to disabled state change
  hooks.useDisabled();

  const isVatEu = hooks.useIsVatEuCountry();
  const isB2bNotificationVisible = hooks.useIsB2bNotificationVisible();
  const isXeroAddonSelected = hooks.useIsXeroAddonSelected();

  const copies = data.getCopies();
  const orderRows = data.getOrderRows(isXeroAddonSelected);
  const footerRows = data.getFooterRows({ isVatEu, isB2bNotificationVisible });
  const subfooterRows = data.getSubfooterRows();

  return (
    <OrderSummary
      copies={copies}
      orderItems={orderRows}
      injectedMiddleComponent={injectedMiddleComponent}
      footerItems={footerRows}
      subfooterItems={subfooterRows}
      hideHeading={hideHeading}
    />
  );
};
